export class Controller {

    /** @ngInject */
    constructor(
        $state,
        Account,
        Alert,
        PasswordAuthenticationPoliciesService,ConfirmModal) {
        this.$state = $state;
        this.Account = Account;
        this.Alert = Alert;
        this.PasswordAuthenticationPoliciesService = PasswordAuthenticationPoliciesService;
        this.ConfirmModal = ConfirmModal;
    }

    $onInit() {
        this.companyId = this.$state.params.companyId;
        this.newPolicy = angular.copy(this.policy);
    }

    notModified() {
        return angular.equals(this.policy, this.newPolicy);
    }

    saveDisabled(form) {
        return form.$invalid || this.notModified();
    }

    save(){
        this.isSaving=true;
        this.PasswordAuthenticationPoliciesService.editPasswordPolicyDetails(this.companyId,this.policy.id,this.newPolicy)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.saved'))
            .finally(() => (this.isSaving = false));
    }

    deletePolicyModal(policyId){
        this.isRemoving=true;
        this.ConfirmModal({
            messageKey:'Do you want to delete this policy?',
            titleKey:'Delete Policy',
            confirmButtonTextKey:'Yes',
        })
            .then(()=>this.PasswordAuthenticationPoliciesService.deletePasswordPolicy(this.companyId,policyId))
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.removed'))
            .finally(() => (this.isRemoving = false));
    }
    resetPolicy(policyId){
        this.isRestoring = true;
        this.ConfirmModal({
            messageKey:'Do you want to restore the policy settings to be the same as the Default Policy?',
            titleKey:'Restore to default',
            confirmButtonTextKey:'Yes',
        })
            .then(() => this.PasswordAuthenticationPoliciesService.resetPasswordPolicy(this.companyId,policyId))
            .then(() => this.$state.reload('company.policies'))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.restored'))
            .finally(() => (this.isRestoring = false))
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/edit-policy/edit-policy.controller.js